import { useEffect, useRef } from "react";

/**
 * Hook to check if the component is mounted for the first time
 * @returns boolean
 */
export const useIsFirstMount = () => {
  const isFirst = useRef(true);
  const result = isFirst.current;

  useEffect(() => {
    isFirst.current = false;
  }, []);

  return result;
};
